import * as React from 'react';

import * as styles from './hero.module.scss';

export interface HeroProps {
  children: React.ReactNode;
  theme?: 'fade';
}

const Hero = ({children, theme}: HeroProps) => {
  return (
    <section className={`${styles.wrapper} ${theme ? styles[theme] : ''}`}>
      <div className={styles.content}>{children}</div>
    </section>
  );
};

export default Hero;
